/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */

import translations from '@atlassian/afm-i18n-platform-townsquare-townsquare-comments/i18n/en';
export default translations;
